var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32845_26983)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 90.8108,
    rx: 45.4054,
    fill: "#0B364B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.59998,
    y: 60.9731,
    width: 101.4,
    height: 32.4324,
    fill: "#064B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.699 24.4323C56.2535 24.4325 55.8086 24.4603 55.3665 24.5154C54.2769 23.1108 52.8795 21.9737 51.2813 21.1914C49.6832 20.4092 47.9267 20.0024 46.1467 20.0024C44.3667 20.0024 42.6103 20.4092 41.0122 21.1914C39.4139 21.9737 38.0166 23.1108 36.9269 24.5154C36.4871 24.4605 36.0444 24.4328 35.6011 24.4323C32.9563 24.4354 30.3912 25.3357 28.3268 26.9855C26.2623 28.6351 24.8213 30.9363 24.2402 33.511C23.6591 36.0858 23.9725 38.7813 25.129 41.1549C26.2854 43.5286 28.2161 45.4393 30.6042 46.5734V58.7837C30.606 60.2526 31.1915 61.6609 32.2323 62.6995C33.2732 63.7381 34.6843 64.3224 36.1563 64.3242H56.1438C57.6158 64.3224 59.0269 63.7381 60.0678 62.6995C61.1086 61.6609 61.6941 60.2526 61.6959 58.7837V46.5734C64.084 45.4393 66.0147 43.5286 67.1711 41.1549C68.3276 38.7813 68.641 36.0858 68.0599 33.511C67.4788 30.9363 66.0377 28.6351 63.9734 26.9855C61.9089 25.3357 59.3438 24.4354 56.699 24.4323Z",
    fill: "#EAEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2667 57.6757V43.1285C35.6895 42.3394 34.2884 41.24 33.1478 39.8967C32.0073 38.5533 31.1507 36.9937 30.6298 35.3114C30.1089 33.6292 29.9343 31.8591 30.1165 30.1079C30.2988 28.3566 30.834 26.6601 31.6902 25.1206C29.5178 25.8901 27.6232 27.2858 26.2464 29.1308C24.8696 30.9758 24.0725 33.1871 23.9562 35.4846C23.8399 37.7821 24.4096 40.0622 25.5931 42.0363C26.7766 44.0104 28.5206 45.5895 30.6042 46.5736V58.7838C30.606 60.2527 31.1915 61.6609 32.2323 62.6996C33.2732 63.7383 34.6843 64.3226 36.1563 64.3244H43.9292C42.1622 64.3244 40.4676 63.6239 39.2181 62.377C37.9686 61.1301 37.2667 59.439 37.2667 57.6757Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6958 55.4595H30.6041V57.6757H61.6958V55.4595Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2666 55.4595H30.6041V57.6757H37.2666V55.4595Z",
    fill: "#C1C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15 44.3784C45.8555 44.3784 45.573 44.4952 45.3648 44.703C45.1566 44.9108 45.0396 45.1927 45.0396 45.4865V49.919C45.0396 50.2128 45.1566 50.4947 45.3648 50.7025C45.573 50.9103 45.8555 51.0271 46.15 51.0271C46.4444 51.0271 46.7269 50.9103 46.9351 50.7025C47.1433 50.4947 47.2604 50.2128 47.2604 49.919V45.4865C47.2604 45.1927 47.1433 44.9108 46.9351 44.703C46.7269 44.4952 46.4444 44.3784 46.15 44.3784Z",
    fill: "#8FA5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8124 45.4863C52.518 45.4863 52.2355 45.6031 52.0273 45.8109C51.8191 46.0187 51.702 46.3006 51.702 46.5944V49.9188C51.702 50.2126 51.8191 50.4945 52.0273 50.7023C52.2355 50.9101 52.518 51.0269 52.8124 51.0269C53.1069 51.0269 53.3894 50.9101 53.5976 50.7023C53.8058 50.4945 53.9229 50.2126 53.9229 49.9188V46.5944C53.9229 46.3006 53.8058 46.0187 53.5976 45.8109C53.3894 45.6031 53.1069 45.4863 52.8124 45.4863Z",
    fill: "#8FA5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4875 45.4863C39.193 45.4863 38.9105 45.6031 38.7023 45.8109C38.4941 46.0187 38.3771 46.3006 38.3771 46.5944V49.9188C38.3771 50.2126 38.4941 50.4945 38.7023 50.7023C38.9105 50.9101 39.193 51.0269 39.4875 51.0269C39.782 51.0269 40.0645 50.9101 40.2727 50.7023C40.4809 50.4945 40.5979 50.2126 40.5979 49.9188V46.5944C40.5979 46.3006 40.4809 46.0187 40.2727 45.8109C40.0645 45.6031 39.782 45.4863 39.4875 45.4863Z",
    fill: "#8FA5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 44.1079L23.2937 48.1059L27.3 48.6485L23.2937 49.1911L22.75 53.189L22.2062 49.1911L18.2 48.6485L22.2062 48.1059L22.75 44.1079Z",
    fill: "#F1B44C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.55 12.9731L70.6572 19.0034L76.7 20.1083L70.6572 21.2132L69.55 27.2434L68.4428 21.2132L62.4 20.1083L68.4428 19.0034L69.55 12.9731Z",
    fill: "#F1B44C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 89,
    height: 88.8108,
    rx: 44.4054,
    stroke: "#3797C8",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32845_26983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 90.8108,
    rx: 45.4054,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChef);
export default __webpack_public_path__ + "static/media/chef.a2cfe1dde337cafebf8e6dad3f5c99c0.svg";
export { ForwardRef as ReactComponent };